// src/components/ORBHeader.jsx
import "./AppHeader.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function ORBHeader() {
  const user = JSON.parse(sessionStorage.getItem("currentUser"));
  const vesselId = sessionStorage.getItem("selectedVesselId");
  const navigate = useNavigate();

  // ✅ Add vessel state
  const [vessel, setVessel] = useState(null);

  // ✅ Fetch vessel details on mount
  useEffect(() => {
    if (!vesselId) return;

    fetch("/api/vessels/")
      .then(res => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}: ${res.statusText}`);
        }
        return res.json();
      })
      .then(data => {
        // ✅ Handle both array and paginated response
        const vesselList = Array.isArray(data) ? data : (data.results || []);

        // ✅ Find the selected vessel
        const selectedVessel = vesselList.find(v => v.id === vesselId);

        if (selectedVessel) {
          setVessel({
            vesselName: selectedVessel.vesselName,
            imoNumber: selectedVessel.imonumber
          });
        } else {
          console.warn("Vessel not found for ID:", vesselId);
          alert(" Vessel not found. Please select a vessel.");
        }
      })
      .catch(err => {
        console.error(" Network error: Cannot load vessel data.", err);
        alert(" Network error: Cannot load vessel data. Check backend.");
      });
  }, [vesselId]);

  // ✅ Logout handler
  const handleLogout = async () => {
    const confirmLogout = window.confirm("Are you sure you want to log out?");
    if (!confirmLogout) return;

    try {
      const selectedVesselId = sessionStorage.getItem("selectedVesselId");
      sessionStorage.removeItem("currentUser");
      sessionStorage.removeItem("authToken");

      if (selectedVesselId) {
        sessionStorage.setItem("selectedVesselId", selectedVesselId);
      }

      alert(" Logged out successfully");
      navigate("/login", { replace: true });
    } catch (err) {
      console.error("Logout failed:", err);
      navigate("/login", { replace: true });
    }
  };

  return (
    <div className="app-header">
      <div className="header-content">
        <h1 className="app-title">
          <span className="title-main">E-ORB</span>
          <span className="title-sub">Logbook</span>
        </h1>

        {/*  Vessel Info in Navbar */}
        <div className="vessel-info">
          {vessel ? (
            <>
              <strong>{vessel.vesselName?.toUpperCase() || "UNKNOWN VESSEL"}</strong>
              
            </>
          ) : (
            "Loading vessel..."
          )}
        </div>

        <div className="user-section">
          <span className="greeting">
            Welcome, <strong>{user?.UserName || user?.username || "USER"}</strong>
            <span className="rank"> ({user?.Rank || "OFFICER"})</span>
          </span>
          <button onClick={handleLogout} className="btn-logout">
             Logout
          </button>
        </div>
      </div>
    </div>
  );
}